/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';

export default class HeaderIcon extends React.Component {
  findLinkSource(link) {
    if (link) {
      if (link.includes('google')) return { name: 'google plus', style: { color: '#DD4B39' } };
      if (link.includes('facebook')) return { name: 'facebook', style: { color: '#3b5998' } };
      if (link.includes('yelp')) return { name: 'yelp', style: { color: '#c41200' } };
      if (link.includes('tripadvisor')) return { name: 'tripadvisor', style: { color: '#00af87' } };
    }

    return { name: '', style: {} };
  }

  renderIcon(iconProps) {
    const { name, style } = iconProps;

    return (
      <span>
        <span> </span>
        <span>
          <Icon name={name} style={style} size="small" />
        </span>
      </span>
    );
  }

  render() {
    const { link, showLink, isVerticalItem } = this.props;
    const iconProps = this.findLinkSource(link);

    // For verticalItems we need to override the default <Header.Content /> CSS in ItemElement
    if (isVerticalItem)
      iconProps.style = { ...iconProps.style, display: 'inline-block', fontSize: '1em' };

    const icon = this.renderIcon(iconProps);

    return link && showLink ? (
      <a href={link} target="_blank">
        {icon}
      </a>
    ) : (
      icon
    );
  }
}

HeaderIcon.propTypes = {
  link: PropTypes.string.isRequired,
  showLink: PropTypes.bool,
  isVerticalItem: PropTypes.bool,
};

HeaderIcon.defaultProps = {
  showLink: true,
  isVerticalItem: false,
};
